import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=87ffd846"
import script from "./SchemaField.vue?vue&type=script&lang=js"
export * from "./SchemaField.vue?vue&type=script&lang=js"
import style0 from "./SchemaField.vue?vue&type=style&index=0&id=87ffd846&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports